import { AlertService } from './alert.service';
import { AuthService, SocialUser } from 'angularx-social-login';
import { ConfigurationService } from './configuration.service';
import { CookieService } from 'ngx-cookie-service';
import { DBkeys } from './db-keys';
import { DOCUMENT } from '@angular/common';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { FormBuilder, Validators, FormGroup, MinLengthValidator, FormControl } from '@angular/forms';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { LocalStoreManager } from './local-store-manager.service';
import { LoginReturn } from 'src/app/models/login.return.model';
// import { map, catchError } from 'rxjs/operators';
import { RegisterModel, PhoneModel, AddressViewModel, RespCheckEmailModel, SignupResultModel } from '../models/register.model';
import { RegisterService } from '../feature-modules/register/register.service';
import { Router, NavigationExtras } from '@angular/router';
import { SocialUserInfo } from '../models/social.model';
import { Subject, Observable, of, throwError } from 'rxjs';
import { User } from '../models/user.model';
import { Utilities } from './utilities';
import { ClaimResultModel, ClaimFinalizationModel } from '../models/claims.model';

@Injectable({
  providedIn: 'root'
})

export class AauthService {

  isSessionExpired: boolean;

  public resultMessage: string;

  public loginRedirectUrl: string;
  public logoutRedirectUrl: string;
  private previousIsLoggedInCheck = false;
  // tslint:disable-next-line: variable-name - test change to push things out CAJ 12-22-20
  private _loginStatus = new Subject<boolean>();

  httpHeaders = new HttpHeaders({
	'Content-Type': 'application/json',
	'Access-Control-Allow-Origin': '*',
	Accept: 'application/json, text/plain, */*'
  });

  httpGetOptions = {
	headers: this.httpHeaders
  };

  formModel2 = this.fb.group({
	corpType: [1],
	email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
	title: [''],
	suffice: [''],
	firstName: ['', [Validators.required]],
	lastName: ['', [Validators.required]],
	country: ['', [Validators.required]],
	postalCode: ['', Validators.required],
	address: ['', [Validators.required]],
	city: ['', [Validators.required]],
	state: ['', [Validators.required]],
	phoneNumber: [''],
	passwords: this.fb.group(
		{
		password: ['', [
			Validators.required,
			// Validators.minLength(6),
			Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d$@$!%*?& ].{6,}')
		]],
		confirmPassword: ['', Validators.required]
		},
		{ validator: this.comparePasswords }
	),
	referrer: [''],
	agree: [false, Validators.requiredTrue],
	recaptcha: [null, Validators.required],
  });

  regModel2 = {
	memberType: 1,
	corpType: 1,
	agree: false,                                                                                                       // crazy Check box by layout.
  };

  finalizeClaimModel = this.fb.group({
	passwords: this.fb.group(
		{
		password: ['', [
			Validators.required,
			// Validators.minLength(6),
			Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d$@$!%*?& ].{6,}')
		]],
		confirmPassword: ['', Validators.required]
		},
		{ validator: this.comparePasswords }
	),
	agree: [false, Validators.requiredTrue],
	recaptcha: [null, Validators.required]
  });

  protected httpOptions = {
	headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Access-Control-Allow-Origin': '*',
					Accept: 'application/json, text/plain, */*'
				})
		, withCredentials: true
	};

  public get baseUrl() { return this.configurations.baseUrl; }
  public get loginUrl() { return this.configurations.loginUrl; }
  public get homeUrl() { return this.configurations.homeUrl; }
  public get tokenUrl() { return this.configurations.apiUrl; }

  constructor(
	private fb: FormBuilder,
	protected http: HttpClient,
	private router: Router,
	private cookieService: CookieService,
	private localStorage: LocalStoreManager,
	private authService: AuthService,
	private configurations: ConfigurationService,
	private alertService: AlertService,
	private registerService: RegisterService,
	@Inject(DOCUMENT) private document: Document,
	) { }

  get currentUser(): User {

	const user = this.localStorage.getDataObject<User>(DBkeys.CURRENT_USER);
	this.reevaluateLoginStatus(user);

	return user;
  }

  get curUserName(): string {
	let ret = '';
	if (this.currentUser) {
		ret = this.currentUser.userName;
	}

	return ret;
  }

  get curFullName(): string {
	let ret = '';
	if (this.currentUser) {
		ret = this.currentUser.fullName;
	}

	return ret;
  }

  get curMsgCounter(): number {
	let ret = 0;
	if (this.currentUser) {
		ret = 2;
	}

	return ret;
  }

  protected get requestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
	const headers = new HttpHeaders({
		Authorization: 'Base ',
		'Content-Type': 'application/json',
		Accept: 'application/json, text/plain, */*'
	});

	return { headers };
  }

  get isLoggedIn(): boolean {
	const res = this.currentUser;
	return res !== null;
  }

  checkLoggedIn(saveUser: boolean = false) {
	const httpUrl = this.tokenUrl + '/Home/GetCurrentUser';
	// check login status from cookie.
	this.http.post(httpUrl, {}, this.httpOptions).toPromise()
	.then(
		(data: any) => {
			// console.log(data);
			const user = new User(data.userId, data.email, data.name, data.email);
			const mLogin = user.id !== undefined && user.id !== '';

			if ((mLogin && saveUser) || (mLogin !== this.previousIsLoggedInCheck)) {
			if (mLogin) {
				this.saveUserDetails(user, true);
			} else {
				this.localStorage.deleteData(DBkeys.USER_PERMISSIONS);
				this.localStorage.deleteData(DBkeys.CURRENT_USER);
			}

			this.reevaluateLoginStatus();
			}
		})
		.catch(
		error => {
			// console.log(error);
		});
  }

  get rememberMe(): boolean {
	return this.localStorage.getDataObject<boolean>(DBkeys.REMEMBER_ME) === true;
  }

  comparePasswords(fb: FormGroup) {
	const ctrlConfirmPwd = fb.get('confirmPassword');
	const ctrlPwd = fb.get('password');
	if (
		ctrlConfirmPwd.errors == null ||
		'passwordMismatch' in ctrlConfirmPwd.errors
	) {
		if (ctrlPwd.value !== ctrlConfirmPwd.value) {
		ctrlConfirmPwd.setErrors({ passwordMismatch: true });
		} else {
		ctrlConfirmPwd.setErrors( null );
		}
	}
  }

  register(pCorpType: number) {
	if (!this.formModel2.get('agree').value) {
		this.alertService.showWarning('Do you agree?');
	}

	if (!this.isLocalHost()) {
		if (!this.formModel2.valid) {
		Utilities.validateAllFormFields(this.formModel2);
		return;
		}
	}
	console.log('register');
	const registerModel = new RegisterModel();
	const phoneModel = new PhoneModel(this.formModel2.get('phoneNumber').value);
	const address = new AddressViewModel(
		this.formModel2.get('country').value,
		this.formModel2.get('postalCode').value,
		this.formModel2.get('address').value,
		this.formModel2.get('city').value,
		this.formModel2.get('state').value
	);
	registerModel.email = this.formModel2.get('email').value;
	registerModel.title = this.formModel2.get('title').value;
	registerModel.suffice = this.formModel2.get('suffice').value;
	registerModel.firstName = this.formModel2.get('firstName').value;
	registerModel.lastName = this.formModel2.get('lastName').value;
	registerModel.addressViewModel = address;
	registerModel.phoneViewModel = phoneModel;
	registerModel.password = this.formModel2.value.passwords.password;
	registerModel.confirmPassword = this.formModel2.value.passwords.confirmPassword;
	const referId = this.formModel2.get('referrer').value;
	registerModel.referId = referId != null ? referId : 0;
	registerModel.termsAgree = this.formModel2.get('agree').value;
	registerModel.corp = this.formModel2.get('corpType').value;
	registerModel.memberType = this.regModel2.memberType;
	registerModel.status = 0;
	registerModel.useExternalProvider = true;
	const provider = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'provider');
	if (provider !== '' && provider !== 'EMAIL') {
		registerModel.externalProviderName = provider;
		registerModel.externalProviderKey = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'providerId');
	}
	const urlPost = this.tokenUrl + '/register/register';
	this.saveModelData(registerModel, true);
	const bodyData = JSON.stringify(registerModel);

	this.alertService.startLoadingMessage();
	this.http.post(urlPost, bodyData, this.httpOptions)
		.subscribe({
		next: (data: any) => {
			this.alertService.stopLoadingMessage();
			this.alertService.showInfo(data.message);
			// console.log(data);
			if (data.success === true) {
			this.localStorage.savePermanentData(registerModel.email, DBkeys.LOCAL_KEY_REG + 'email');
			this.localStorage.savePermanentData(registerModel.phoneViewModel.PhoneNumber, DBkeys.LOCAL_KEY_REG + 'phone');
			this.localStorage.savePermanentData(3, DBkeys.LOCAL_KEY_REG + 'step');
			this.registerService.regStep = 3;
			this.router.navigateByUrl('/register/step3');
			}
		},
		error: error => {
			this.alertService.stopLoadingMessage();
			this.ShowErrorMessage(error);
		}
		});
  }

  getLoginStatusEvent() {
	return this._loginStatus.asObservable();
  }

  redirectLoginUser() {
	const redirect = this.loginRedirectUrl && this.loginRedirectUrl !== '/'
		&& this.loginRedirectUrl !== ConfigurationService.defaultHomeUrl ? this.loginRedirectUrl : this.homeUrl;
	this.loginRedirectUrl = null;

	const urlParamsAndFragment = Utilities.splitInTwo(redirect, '#');
	const urlAndParams = Utilities.splitInTwo(urlParamsAndFragment.firstPart, '?');

	const navigationExtras: NavigationExtras = {
		fragment: urlParamsAndFragment.secondPart,
		queryParams: Utilities.getQueryParamsFromString(urlAndParams.secondPart),
		queryParamsHandling: 'merge'
	};

	this.router.navigate([urlAndParams.firstPart], navigationExtras);
  }

  gotoHomePage() {
	this.router.navigateByUrl('/');
  }

  gotoPage(page: string, preserveParams = true) {

	const navigationExtras: NavigationExtras = {
		queryParamsHandling: preserveParams ? 'merge' : '', preserveFragment: preserveParams
	};

	this.router.navigate([page], navigationExtras);
  }

  gotoLastPage() {
	// if (this.loginRedirectUrl !== '') {
	//   this.gotoPage(this.loginRedirectUrl);Password Recovery
	// } else {
		this.gotoHomePage();
	// }
  }

  gotoRecoverPassword(isFlyout: boolean) {
	this.document.location.href = `/Register/ForgotPassword`;                                                           // CAJ 07-12-2020 -> can't support this because of the need to send an email ?isFlyout=${isFlyout}`;
  }

  gotoPrivacyPolicy() {
	this.document.location.href = '/PrivacyPolicy';
  }

  gotoTermsOfUse() {
	this.document.location.href = '/TermsOfUse';
  }

  gotoRegister() {
   this.gotoPage('/register');
  }

  locationTo(pUrl: string) {
	window.location.href = pUrl;
  }

  ShowErrorMessage(error: any) {
	// console.log(error);
	this.alertService.showError(error);
  }

  private handleError<T>(operation = 'operation', result?: T) {
	return (error: any): Observable<T> => {
		// console.error(error);
		this.log(`${operation} failed: ${error.message}`);

		return throwError(of(result as T));
	};
  }

  private log(message: string) {
	console.log(message);
  }

  private reevaluateLoginStatus(currentUser?: User) {
	const user = currentUser || this.localStorage.getDataObject<User>(DBkeys.CURRENT_USER);
	const isLoggedIn = user != null;

	if (this.previousIsLoggedInCheck !== isLoggedIn) {
		setTimeout(() => {
		this._loginStatus.next(isLoggedIn);
		});
	}

	this.previousIsLoggedInCheck = isLoggedIn;
  }

  async signupUsingSocialToken(info: SocialUser, corpType: number = 0) {
	console.log(info);
	const mbrType = info.isClaim ? 5 : 1;                                                                               // 08-13-2021 - dwn: 5=professional, 1=consumer
	const user = new SocialUserInfo(info.id, info.name, info.email, info.photoUrl,
		info.firstName, info.lastName, info.authToken, info.provider, info.idToken ?? info.authToken,
		mbrType, corpType, info.isClaim);

	const bodyData = JSON.stringify(user);
	const endpointUrl = this.tokenUrl + '/Register/Signup';

	try {
		return this.http.post(endpointUrl, bodyData, this.httpOptions)
		.toPromise().then(
			(respData: any) => {
			if (info.isClaim) {
				info.email = respData.professionalModel.email;
			}
			this.saveModelData(respData, false);
			return JSON.stringify(respData);
		})
		.catch(e => {
			throw new Error(Utilities.getHttpResponseMessage(e));
		});
	} catch (error) {
		this.ShowErrorMessage(error);
		return throwError(error);
	}
  }

  saveModelData(model, isRegModel: boolean) {
	  if (model.professionalModel !== undefined) {
		  this.localStorage.savePermanentData(JSON.stringify(model), DBkeys.LOCAL_KEY_REG);
		  this.localStorage.savePermanentData(model.provider, DBkeys.LOCAL_KEY_REG + 'provider');
		  this.localStorage.savePermanentData(model.professionalModel.email, DBkeys.LOCAL_KEY_REG + 'email');
		  this.localStorage.savePermanentData(model.professionalModel.corp, DBkeys.LOCAL_KEY_REG + 'corp');
		  this.localStorage.savePermanentData(model.professionalModel.id, DBkeys.LOCAL_KEY_REG + 'providerId');
		  this.localStorage.savePermanentData(model.hasProfessionalAreas, DBkeys.LOCAL_KEY_REG + 'hasProfessionalAreas');
		} else if (isRegModel) {
			this.localStorage.savePermanentData(JSON.stringify(model), DBkeys.LOCAL_KEY_REG);
			this.localStorage.savePermanentData(model.provider, DBkeys.LOCAL_KEY_REG + 'provider');
			this.localStorage.savePermanentData(model.email, DBkeys.LOCAL_KEY_REG + 'email');
			this.localStorage.savePermanentData(model.corp, DBkeys.LOCAL_KEY_REG + 'corp');
			this.localStorage.savePermanentData(model.id, DBkeys.LOCAL_KEY_REG + 'providerId');
			if (model.hasProfessionalAreas) {
			this.localStorage.savePermanentData(model.hasProfessionalAreas, DBkeys.LOCAL_KEY_REG + 'hasProfessionalAreas');
			}
		} else {
			this.localStorage.savePermanentData(model.Email, DBkeys.LOCAL_KEY_REG + 'email');
			this.localStorage.savePermanentData(model.Corp, DBkeys.LOCAL_KEY_REG + 'corp');
		}
	}

  async signupWithFacebook(memberType: number = 0) {
	  // try {
		  const response = await this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
		  return await this.signupUsingSocialToken(response, memberType);
	  // } catch (error) {
	  //   return this.handleError('signupWithFacebook', error);
	  // }
  }

  async signupWithGoogle(memberType: number = 0) {
	  const response = await this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
	  return await this.signupUsingSocialToken(response, memberType);
  }

  async signupWithEmail(pId: number, pCorP: number = 1, isClaim: boolean = false, email: string = '') {
	  // tslint:disable-next-line: prefer-const
	  let user = new SocialUser();
	  user.id = pId;
	  user.isClaim = isClaim;
	  user.provider = 'EMAIL';
	  user.email = email;

	  return this.signupUsingSocialToken(user, pCorP);
  }

  cleanupSessionReg() {
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG, true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'provider', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'providerId', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'email', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'corp', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'phone', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'hasProfessionalAreas', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'step', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'states', true);
	  this.localStorage.deleteData(DBkeys.LOCAL_KEY_REG + 'countries', true);
  }

  saveStates(states) {
	  this.localStorage.savePermanentData(states, DBkeys.LOCAL_KEY_REG + 'states');
  }

  saveCountries(countries) {
	  this.localStorage.savePermanentData(countries, DBkeys.LOCAL_KEY_REG + 'countries');
  }

  saveTitles(titles) {
	  this.localStorage.savePermanentData(titles, DBkeys.LOCAL_KEY_REG + 'titles');
  }

  sendCaptchaToBackend(captcha: any) {
	  const urlPost = this.configurations.apiUrl + '/register/ValidateRecaptcha';
	  return this.http.post(urlPost, {recaptchaResponse: captcha}, this.httpOptions);
  }

  sendActiveCodeByEmail(pEmail: string) {
	  this.alertService.startLoadingMessage('Proccess..');
	  const urlPost = this.configurations.apiUrl + '/register/ResendVerificationEmail';
	  const bodyData = JSON.stringify({ email: pEmail });
	  this.http.post(urlPost, bodyData, this.httpOptions)
		  .subscribe({
		  next: (data: any) => {
			  // console.log(data);
			  this.alertService.stopLoadingMessage();
			  this.alertService.showInfo(data);
		  },
		  error: error => {
			  this.alertService.stopLoadingMessage();
			  this.ShowErrorMessage(error);
		  }
		});
  }

  sendActiveCodeByPhone(pEmail: string, pPhone: string) {
	  if (pEmail === '') {
		  this.alertService.showWarning('Invalid email');
		  return;
	  }
	  if (pPhone === '') {
		  this.alertService.showWarning('Invalid phone number');
		  return;
	  }

	  const urlPost = this.configurations.apiUrl + '/register/SendVerificationSMS';
	  const bodyData = JSON.stringify({ email: pEmail, phone: pPhone });
	  this.http.post(urlPost, bodyData, this.httpOptions)
		  .subscribe({
		  next: (data: any) => {
			  // console.log(data);
			  this.alertService.showInfo(data);
		  },
		  error: error => {
			  this.ShowErrorMessage(error);
		  }
		});
  }

  validActiveCode( pCode: string, pByEmail: boolean, pEmail: string, pPhone: string, isConsumer: boolean, isFlyout: boolean) {
	  // Case email..
	  const urlPost = this.configurations.apiUrl + '/register/ConfirmCodeByEmail';
	  const bodyData = JSON.stringify({ email: pEmail, phone: pPhone, code: pCode });
	  this.http.post(urlPost, bodyData, this.httpOptions)
		  .subscribe({
		  next: (data: any) => {
			  if (data === true) {
				const hasAreas = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'hasProfessionalAreas');
				this.cleanupSessionReg();                                                                                   // clear up localStorage when done
				if (isConsumer) {
					if (isFlyout) {
					  $('#btnCallback').click();
					} else {
					  this.locationTo('/Home');
					}
				} else {
					if (!hasAreas) {                                                                                          // if new or don't have any professional areas goto step 4 else goto profile
					  this.registerService.regStep = 4;
					  this.router.navigate(['/register/profile']);
					} else {
					  this.locationTo('/Professional/Edit');
					}
				}
			  } else { this.alertService.showError('Unable to verify, please recheck your verification code.'); }
		  },
		  error: error => {
			  this.ShowErrorMessage(error);
		  }
		});
  }

  /// ---------------------------------------------------------------------------------
  // Call login get token facebook,
  // Send info to backend to login.
  ///
  async signInWithFB() {
	try {
		const response = await this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
		// console.log(response);
		const info = new SocialUserInfo(response.id, response.name, response.email, response.photoUrl,
			response.firstName, response.lastName, response.authToken, response.provider,
			response.idToken, -1, 1, false);
		return this.fetchTokenUsingFBFlow(info);
	} catch (error) {
		  // console.log(error);
		  return this.handleError('aauthService.signInWithFB', error);
	}
  }

  /// ---------------------------------------------------------------------------------
  // Call login get token google,
  // Send info to backend to login.
  ///
  async signInWithGoogle() {
	try {
		const response = await this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
		const info = new SocialUserInfo(response.id, response.name, response.email, response.photoUrl,
		response.firstName, response.lastName, response.authToken, response.provider,
		response.idToken, -1, 1, false);

		return this.fetchTokenUsingGoogleFlow(info);
	} catch (error) {
		  return this.handleError('aauthService.signInWithGoogle', error);
	}
  }

  async login(userName: string, password: string, rememberMe: boolean) {
	  if (this.isLoggedIn) {
		  this.logout();
	  }

	  const endpointUrl = this.configurations.apiUrl + '/Authorization/Login/';
	  const bodyData = JSON.stringify({ UserName: userName, Password: password, RememberMe: rememberMe });
	  try {
		  return this.http.post(endpointUrl, bodyData, this.httpOptions)
		  .toPromise().then(                                                                                                  // Wait for responce
		  (repData: LoginReturn) => {
			  const user = new User('', userName);
			  this.processLoginResponse(user, rememberMe);
			  return repData;
		  }
		  )
		  .catch(e => {
			  throw new Error(Utilities.getHttpResponseMessage(e));
		  });
	  } catch (error) {
		  // console.log(error);
		  return this.handleError('fetchTokenUsingAuthXFlow', error);
	  }
  }

  redirectForLogin() {
	  this.loginRedirectUrl = this.router.url;
	  this.router.navigate([this.loginUrl]);
  }

  logout() {
	  this.localStorage.deleteData(DBkeys.USER_PERMISSIONS);
	  this.localStorage.deleteData(DBkeys.CURRENT_USER);

	  this.configurations.clearLocalChanges();
	  this.authService.signOut(true);

	  this.reevaluateLoginStatus();

	  const endpointUrl = this.configurations.apiUrl + '/Authorization/LogOff';
	  // console.log('begin post: ' + bodyData);
   try {
		return this.http.post(endpointUrl, {}, this.httpOptions)
		.toPromise().then(                                                                    // Wait for response
		  (repData: any) => {
			console.log('post response: ' + Utilities.getResponseBody(repData));
		  })
		.catch(e => {
			throw new Error(Utilities.getHttpResponseMessage(e));
		});
		} catch (error) {
		  // console.log(error);
		  return this.handleError('fetchTokenUsingAuthXFlow', error);
		}
  }

  ///
  // post to backend for Login.
  ///
  private fetchTokenUsingAuthXFlow(endpointUrl: string, info: SocialUserInfo) {
	  const bodyData = JSON.stringify(info);
	  try {
		  return this.http.post(endpointUrl, bodyData, this.httpOptions)
		  .toPromise().then(
			  (repData: any) => {
			  //  const data = JSON.stringify(repData);
			  //  console.log('post response: ' + data);
			  const user = new User(info.Email, info.Email, info.FirstName, info.Email);
			  this.processLoginResponse(user, true);
			  this.checkLoggedIn(true);
			  return user;
		  }
		).catch(e => {
			throw new Error(Utilities.getHttpResponseMessage(e));
		});
	  } catch (error) {
		  // this.ShowErrorMessage(error);
		  return this.handleError('fetchTokenUsingAuthXFlow', error);
	  }
	  // console.log('end post!');
  }

  private fetchTokenUsingGoogleFlow(socialInfo: SocialUserInfo) {
	  const endpointUrl = this.configurations.apiUrl + '/Authorization/ExternalSignin';
	  return this.fetchTokenUsingAuthXFlow(endpointUrl, socialInfo);
	}

  private fetchTokenUsingFBFlow(socialInfo: SocialUserInfo) {
	  const endpointUrl = this.configurations.apiUrl + '/Authorization/ExternalSignin';
	  // console.log(endpointUrl)
	  return this.fetchTokenUsingAuthXFlow(endpointUrl, socialInfo);
  }

  public isLocalHost() {
	  return window.location.href.indexOf('localhost') >= 0;
  }

  private processLoginResponse(data: User, rememberMe: boolean) {
	this.saveUserDetails(data, rememberMe);
	  this.reevaluateLoginStatus(data);

	  return data;
  }

  private saveUserDetails(user: User, rememberMe: boolean) {
	  if (rememberMe) {
		  this.localStorage.savePermanentData(user, DBkeys.CURRENT_USER);
	  } else {
		  this.localStorage.saveSyncedSessionData(user, DBkeys.CURRENT_USER);
	  }

	  this.localStorage.savePermanentData(rememberMe, DBkeys.REMEMBER_ME);
  }

  getEmailInformation(pEmail: string): Observable<RespCheckEmailModel> {
	  const urlPost = this.configurations.apiUrl + '/register/GetEmailInformation';
	  return this.http.post<RespCheckEmailModel>(urlPost, {email: pEmail}, this.httpOptions);
  }

  // New Claims code - CAJ 08-23-20
  sendVerificationEmail(pId: number): Observable<ClaimResultModel> {
	  const urlPost = this.configurations.apiUrl + '/register/SendClaimConfirmationEmail';
	  return this.http.post<ClaimResultModel>(urlPost, { id: pId }, this.httpOptions);
  }

  claimVerification(pId: number): Observable<SignupResultModel> {
	  const url = this.configurations.apiUrl + `/register/ClaimVerificationById`;
	  return this.http.post<SignupResultModel>(url, { id: pId }, this.httpOptions);
  }

  verifyClaimToken(pId: number, token: string): Observable<ClaimResultModel> {
	  const url = this.configurations.apiUrl + `/register/VerifyClaimToken`;
	  return this.http.post<ClaimResultModel>(url, { id: pId, token}, this.httpOptions);
  }

  finalizeClaim(claimModel: ClaimFinalizationModel) {
	  const url = this.configurations.apiUrl + `/register/FinalizeClaim`;
	  return this.http.post<ClaimResultModel>(url, { claim: claimModel}, this.httpOptions);
  }
}
